import moment from "moment";
import constants from "@tracking/utils/constants";
import { CompileDataType } from "./models";

const { DATE_FORMAT } = constants;

export const compileDataAcoes = (data) => {
  let acaoIndenizatoria: CompileDataType = {
    tipoAtuacao: "Ação Indenizatória",
    barColor: "#B15856",
    icon: "attach_money",
    colorIcon: "177, 88, 86",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let acaoCritica: CompileDataType = {
    tipoAtuacao: "Ação Critica",
    barColor: "#F79647",
    icon: "warning",
    colorIcon: "247, 150, 71",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let acaoDeterminante: CompileDataType = {
    tipoAtuacao: "Ação Determinante",
    barColor: "#F1F127",
    icon: "attach_money",
    colorIcon: "241, 241, 39",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let acaoPreventiva: CompileDataType = {
    tipoAtuacao: "Ação Preventiva",
    barColor: "#58C33C",
    icon: "attach_money",
    colorIcon: "88, 195, 60",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let semClassificacao: CompileDataType = {
    tipoAtuacao: "Sem Classificação",
    barColor: "#998f8f",
    icon: "attach_money",
    colorIcon: "153, 143, 143",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let tiposAtuacao: any = [];
  data.forEach((item: any) => {
    switch (item.atuacao) {
      case "Ação Indenizatória": {
        acaoIndenizatoria.data = acaoIndenizatoria.data.concat(item);
        acaoIndenizatoria.totalPedidos =
          acaoIndenizatoria.totalPedidos + item.quantidade;
        acaoIndenizatoria.totalPercentual =
          acaoIndenizatoria.totalPercentual + item.percentual;
        acaoIndenizatoria.totalValor =
          acaoIndenizatoria.totalValor + item.valor;
        return;
      }
      case "Ação Critica": {
        acaoCritica.data = acaoCritica.data.concat(item);
        acaoCritica.totalPedidos = acaoCritica.totalPedidos + item.quantidade;
        acaoCritica.totalPercentual =
          acaoCritica.totalPercentual + item.percentual;
        acaoCritica.totalValor = acaoCritica.totalValor + item.valor;
        return;
      }
      case "Ação Determinante": {
        acaoDeterminante.data = acaoDeterminante.data.concat(item);
        acaoDeterminante.totalPedidos =
          acaoDeterminante.totalPedidos + item.quantidade;
        acaoDeterminante.totalPercentual =
          acaoDeterminante.totalPercentual + item.percentual;
        acaoDeterminante.totalValor = acaoDeterminante.totalValor + item.valor;
        return;
      }
      case "Ação Preventiva": {
        acaoPreventiva.data = acaoPreventiva.data.concat(item);
        acaoPreventiva.totalPedidos =
          acaoPreventiva.totalPedidos + item.quantidade;
        acaoPreventiva.totalPercentual =
          acaoPreventiva.totalPercentual + item.percentual;
        acaoPreventiva.totalValor = acaoPreventiva.totalValor + item.valor;
        return;
      }
      case "Sem Classificação": {
        semClassificacao.data = semClassificacao.data.concat(item);
        semClassificacao.totalPedidos =
          semClassificacao.totalPedidos + item.quantidade;
        semClassificacao.totalPercentual =
          semClassificacao.totalPercentual + item.percentual;
        semClassificacao.totalValor = semClassificacao.totalValor + item.valor;
        return;
      }
    }
  });
  tiposAtuacao.push(
    acaoIndenizatoria,
    acaoCritica,
    acaoDeterminante,
    acaoPreventiva,
    semClassificacao
  );
  return tiposAtuacao;
};

export const compileDataIndicadores = (data) => {
  let indicadorExpedicao: CompileDataType = {
    tipoAtuacao: "Expedição",
    barColor: "#3492DF",
    icon: "attach_money",
    colorIcon: "52, 146, 223",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let indicadorAberto: CompileDataType = {
    tipoAtuacao: "Aberto",
    barColor: "#04ADA0",
    icon: "track_changes",
    colorIcon: "4, 173, 160",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let indicadorInsucesso: CompileDataType = {
    tipoAtuacao: "Insucesso",
    barColor: "#EC6161",
    icon: "money_off",
    colorIcon: "236, 97, 97",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let indicadorFinalizados: CompileDataType = {
    tipoAtuacao: "Finalizados",
    barColor: "#8CE973",
    icon: "check_circle",
    colorIcon: "140, 233, 115",
    totalPedidos: 0,
    totalPercentual: 0,
    totalValor: 0,
    data: [],
  };
  let tiposIndicadores: any = [];
  data.forEach((item: any) => {
    switch (item.idIndicador) {
      case "Expedição": {
        indicadorExpedicao.data = indicadorExpedicao.data.concat({
          ...item,
          idData: moment(item.idData).format(DATE_FORMAT.FIELD),
        });
        indicadorExpedicao.totalPedidos =
          indicadorExpedicao.totalPedidos + item.quantidade;
        indicadorExpedicao.totalValor =
          indicadorExpedicao.totalValor + item.valor;
        return;
      }
      case "Aberto": {
        indicadorAberto.data = indicadorAberto.data.concat({
          ...item,
          idData: moment(item.idData).format(DATE_FORMAT.FIELD),
        });
        indicadorAberto.totalPedidos =
          indicadorAberto.totalPedidos + item.quantidade;
        indicadorAberto.totalValor = indicadorAberto.totalValor + item.valor;
        return;
      }
      case "Insucesso": {
        indicadorInsucesso.data = indicadorInsucesso.data.concat({
          ...item,
          idData: moment(item.idData).format(DATE_FORMAT.FIELD),
        });
        indicadorInsucesso.totalPedidos =
          indicadorInsucesso.totalPedidos + item.quantidade;
        indicadorInsucesso.totalValor =
          indicadorInsucesso.totalValor + item.valor;
        return;
      }
      case "Finalizados": {
        indicadorFinalizados.data = indicadorFinalizados.data.concat({
          ...item,
          idData: moment(item.idData).format(DATE_FORMAT.FIELD),
        });
        indicadorFinalizados.totalPedidos =
          indicadorFinalizados.totalPedidos + item.quantidade;
        indicadorFinalizados.totalValor =
          indicadorFinalizados.totalValor + item.valor;
        return;
      }
    }
  });
  tiposIndicadores.push(
    indicadorExpedicao,
    indicadorAberto,
    indicadorInsucesso,
    indicadorFinalizados
  );
  return tiposIndicadores;
};

export const transformInObjectArray = (array: string[] = []) => {
  let newArray: any = [];
  if (array.length) {
    array.forEach((item: any) => {
      newArray.push({ name: String(item) });
    });
  }
  return newArray;
};

export const transformUniqueArray = (array: any[]) => {
  let newArray: any = [];
  array.forEach((item: any) => {
    newArray.push({ name: String(item) });
  });
  return newArray;
};

export const defaultColumsHeaderTableAcareacoes = [
  "Prazo de acariação",
  "Comprador",
  "Nota fiscal",
  "Pedido",
  "Data entrega",
  "Status",
];
